import React from 'react';
import _ from 'lodash';
import {Grid} from 'semantic-ui-react';
import {TextAreaFieldFrom as TextAreaField} from 'app-ui-componentlibrary';
import {
  InlineSelect,
  InlineMultiSelect,
} from 'app-ui-componentlibrary/dist/go/components/common/FormControls';
import {
  isLocationBuildingInventoryType,
  isLocationInfrastructureInventoryType,
  getOptionText,
} from 'go/components/dynamic/modules/projectSiteInventory/utils';

const defaultSelected = {
  text: 'Select',
  value: null,
  key: 'select-default',
};

const UNCATEGORIZED_OTHER = 'OTHR';

const otherstyle = {
  paddingTop: '16px',
};

export class MitigationInformation extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      allActs: {},
      selectedPrimaryHazards: _.get(
        this.props.inventoryItem,
        ['payload', 'primaryHazards', '0'],
        []
      ),
      selectedSecondaryHazards: _.get(
        this.props.inventoryItem,
        ['payload', 'secondaryHazards'],
        []
      ),
      remainingPrimaryHazards: [],
      remainingSecondaryHazards: [],
    };
  }

  componentDidUpdate = (prevProps) => {
    if (
      !_.isEqual(this.props.options, prevProps.options) ||
      !_.isEqual(this.props.inventoryItem, prevProps.inventoryItem)
    ) {
      let primaryHazards = _.get(
        this.props.inventoryItem,
        ['payload', 'primaryHazards', '0'],
        []
      );
      let secondaryHazards = _.get(
        this.props.inventoryItem,
        ['payload', 'secondaryHazards'],
        []
      );
      let newPrimaryHazards = _.map([...this.props.options.hazardTypes], (elem) => ({
        ...elem,
        selected: false,
      }));
      let newSecondaryHazards = _.map([...this.props.options.hazardTypes], (elem) => ({
        ...elem,
        selected: false,
      }));
      let idx = _.findIndex(newSecondaryHazards, {value: primaryHazards});
      if (idx >= 0) {
        newSecondaryHazards.splice(idx, 1);
      }
      secondaryHazards.map((item) => {
        let idx = _.findIndex(newPrimaryHazards, {value: item});
        if (idx >= 0) {
          newPrimaryHazards.splice(idx, 1);
        }
      });
      this.setState({
        remainingPrimaryHazards: newPrimaryHazards,
        remainingSecondaryHazards: newSecondaryHazards,
        selectedPrimaryHazards: primaryHazards,
        selectedSecondaryHazards: _.compact(secondaryHazards),
      });
    }
  };

  generateSecondaryMitigationActions = (primaryList, primarySelection) => {
    let secondaryList = _.cloneDeep(primaryList);
    if (primarySelection !== undefined && primarySelection !== '') {
      for (let i = 0; i < primaryList.length; i++) {
        if (primaryList[i].value === primarySelection) {
          secondaryList.splice(i, 1);
        }
      }
      return secondaryList;
    } else {
      return primaryList;
    }
  };

  selectFromList = (e, data) => {
    const name = _.get(e, 'target.name') || _.get(data, 'name');
    let value = [];
    let id = '';
    if (data) {
      value = data.value;
      id = data.id;
    } else {
      value.push(e.target.value);
      id = e.target.id;
    }

    if (id === 'primary-hazard-mitigated-control') {
      if (!(value === 'OTHR')) {
        this.setState({selectedPrimaryHazards: value, primaryHazardsOther: ''});
        this.props.saveLocationEntity({
          dataPath: 'payload.primaryHazardsOther',
          value: null,
        });
      } else this.setState({selectedPrimaryHazards: value});
    } else if (id === 'secondary-hazard-mitigated-control') {
      if (
        !(value === 'OTHR') &&
        this.state.selectedSecondaryHazards.includes(UNCATEGORIZED_OTHER)
      ) {
        this.setState({selectedSecondaryHazards: value, secondaryHazardsOther: ''});
        this.props.saveLocationEntity({
          dataPath: 'payload.secondaryHazardsOther',
          value: null,
        });
      } else this.setState({selectedSecondaryHazards: value});
    }

    this.props.saveLocationEntity({
      dataPath: name,
      value: value,
    });
  };

  updateHazardList = async (e, data) => {
    let id = '';
    if (data) {
      id = data.id;
    } else {
      id = e.target.id;
    }
    const {selectedPrimaryHazards, selectedSecondaryHazards} = this.state;
    let newPrimaryHazards = _.map([...this.props.options.hazardTypes], (elem) => ({
      ...elem,
      selected: false,
    }));
    let newSecondaryHazards = _.map([...this.props.options.hazardTypes], (elem) => ({
      ...elem,
      selected: false,
    }));
    let idx = _.findIndex(newSecondaryHazards, {
      value: selectedPrimaryHazards,
    });
    if (idx >= 0) {
      newSecondaryHazards.splice(idx, 1);
    }
    selectedSecondaryHazards.map((item) => {
      let idx = _.findIndex(newPrimaryHazards, {value: item});
      if (idx >= 0) {
        newPrimaryHazards.splice(idx, 1);
      }
    });
    newPrimaryHazards[0] = {...newPrimaryHazards[0], selected: false}; // are these needed??
    newSecondaryHazards[0] = {...newSecondaryHazards[0], selected: false};
    this.setState({
      remainingPrimaryHazards: newPrimaryHazards,
      remainingSecondaryHazards: newSecondaryHazards,
    });
    if (id === 'primary-hazard-mitigated-control') {
      await this.props.handleMultiSelect(
        'payload.primaryHazards',
        selectedPrimaryHazards
      );
      this.props.handleBlur({
        target: {
          name: 'payload.primaryHazards',
          value: selectedPrimaryHazards,
        },
      });
    }
    if (id === 'secondary-hazard-mitigated-control') {
      await this.props.handleMultiSelect(
        'payload.secondaryHazards',
        selectedSecondaryHazards
      );
      this.props.handleBlur({
        target: {
          name: 'payload.secondaryHazards',
          value: selectedSecondaryHazards,
        },
      });
    }
  };

  render() {
    const {displayType, locationType, options, inventoryItem} = this.props;
    const isBuilding = isLocationBuildingInventoryType(locationType);
    const isInfrastructure = isLocationInfrastructureInventoryType(locationType);

    if (_.isEmpty(inventoryItem) || _.isEmpty(_.get(inventoryItem, 'location')))
      return <p>No data available</p>;

    const {
      primaryMitigationAction,
      secondaryMitigationActions,
      primaryHazards,
      primaryHazardsOther,
      secondaryHazards,
      secondaryHazardsOther,
    } = inventoryItem.payload;

    const viewOptions = {
      mitigationActions: _.get(options, 'mitigationActions', []),
      hazards: _.get(options, 'hazardTypes', []),
    };
    return (
      <div id="mitigation-information">
        <Grid>
          <Grid.Row>
            <React.Fragment>
              <Grid.Column mobile={16} computer={8}>
                <div id="primary-mitigation-action">
                  {displayType === 'view' ? (
                    <React.Fragment>
                      <p className="label">Primary mitigation action</p>
                      {getOptionText(
                        viewOptions.mitigationActions,
                        primaryMitigationAction
                      )}
                    </React.Fragment>
                  ) : (
                    <div className="util--full-width ui form">
                      {options && (
                        <InlineSelect
                          id="primary-mitigation-action-control"
                          label="Primary mitigation action"
                          name="payload.primaryMitigationAction"
                          options={[defaultSelected, ...viewOptions.mitigationActions]}
                          value={primaryMitigationAction}
                          handleChange={this.props.handleChange}
                          handleBlur={this.props.handleBlur}
                          displayError={this.props.displayError(
                            'payload.primaryMitigationAction'
                          )}
                          errorMessages={this.props.getErrorMessage(
                            'payload.primaryMitigationAction',
                            'Primary mitigation action'
                          )}
                        />
                      )}
                    </div>
                  )}
                </div>
              </Grid.Column>
              <Grid.Column mobile={16} computer={8}>
                <div id="secondary-mitigation-action">
                  {displayType === 'view' ? (
                    <React.Fragment>
                      <p className="label">
                        Secondary mitigation action <span>(Optional)</span>
                      </p>
                      {getOptionText(
                        viewOptions.mitigationActions,
                        secondaryMitigationActions
                      )}
                    </React.Fragment>
                  ) : (
                    <div className="util--full-width ui form">
                      {options && (
                        <InlineSelect
                          id="secondary-mitigation-action-control"
                          label="Secondary mitigation action"
                          optional={true}
                          name="payload.secondaryMitigationActions"
                          options={[
                            defaultSelected,
                            ...this.generateSecondaryMitigationActions(
                              viewOptions.mitigationActions,
                              primaryMitigationAction
                            ),
                          ]}
                          value={secondaryMitigationActions}
                          handleChange={this.props.handleChange}
                          handleBlur={this.props.handleBlur}
                        />
                      )}
                    </div>
                  )}
                </div>
              </Grid.Column>
            </React.Fragment>
          </Grid.Row>
          <Grid.Row>
            <React.Fragment>
              <Grid.Column mobile={16} computer={8}>
                <div id="primary-hazard-mitigated">
                  {displayType === 'view' ? (
                    <React.Fragment>
                      <p className="label">Primary hazard to be mitigated</p>
                      {getOptionText(viewOptions.hazards, primaryHazards)}
                    </React.Fragment>
                  ) : (
                    <React.Fragment>
                      <div className="util--full-width ui form">
                        <InlineSelect
                          id="primary-hazard-mitigated-control"
                          label="Primary hazard to be mitigated"
                          name="payload.primaryHazards"
                          options={[
                            defaultSelected,
                            ..._.sortBy(this.state.remainingPrimaryHazards, 'text'),
                          ]}
                          value={this.state.selectedPrimaryHazards}
                          handleChange={this.selectFromList}
                          handleBlur={this.updateHazardList}
                          displayError={this.props.displayError('payload.primaryHazards')}
                          errorMessages={this.props.getErrorMessage(
                            'payload.primaryHazards',
                            'Primary hazard to be mitigated'
                          )}
                        />
                      </div>
                      {this.state.selectedPrimaryHazards === UNCATEGORIZED_OTHER && (
                        <div style={otherstyle}>
                          <div className="util--full-width ui form">
                            <TextAreaField
                              label="If uncategorized, please specify"
                              maxLength={4000}
                              id="primary-hazard-mitigated-other-control"
                              title="If uncategorized, please specify"
                              name="payload.primaryHazardsOther"
                              displayError={this.props.displayError(
                                'payload.primaryHazardsOther'
                              )}
                              errorMessages={'Description is required'}
                              value={primaryHazardsOther}
                              handleBlur={this.props.handleBlur}
                              handleChange={this.props.handleChange}
                            />
                          </div>
                        </div>
                      )}
                    </React.Fragment>
                  )}
                </div>
              </Grid.Column>
              <Grid.Column mobile={16} computer={8}>
                <React.Fragment>
                  <div id="secondary-hazard-mitigated">
                    {displayType === 'view' ? (
                      <React.Fragment>
                        <p className="label">
                          Secondary hazard(s) to be mitigated <span>(Optional)</span>
                        </p>
                        {getOptionText(viewOptions.hazards, secondaryHazards)}
                      </React.Fragment>
                    ) : (
                      <div className="util--full-width ui form">
                        <InlineMultiSelect
                          id="secondary-hazard-mitigated-control"
                          label="Secondary hazard(s) to be mitigated"
                          optional={true}
                          options={[
                            defaultSelected,
                            ..._.sortBy(this.state.remainingSecondaryHazards, 'text'),
                          ]}
                          name="payload.secondaryHazards"
                          value={this.state.selectedSecondaryHazards}
                          onChange={this.selectFromList}
                          onBlur={this.updateHazardList}
                          selectedLabel={null}
                        />
                      </div>
                    )}
                  </div>
                  {this.state.selectedSecondaryHazards.includes(UNCATEGORIZED_OTHER) && (
                    <div style={otherstyle}>
                      <div className="util--full-width ui form">
                        <TextAreaField
                          label="If uncategorized, please specify"
                          maxLength={4000}
                          id="secondary-hazard-mitigated-other-control"
                          title="If uncategorized, please specify"
                          name="payload.secondaryHazardsOther"
                          value={secondaryHazardsOther}
                          displayError={this.props.displayError(
                            'payload.secondaryHazardsOther'
                          )}
                          errorMessages={'Description is required'}
                          handleBlur={this.props.handleBlur}
                          handleChange={this.props.handleChange}
                        />
                      </div>
                    </div>
                  )}
                </React.Fragment>
              </Grid.Column>
            </React.Fragment>
          </Grid.Row>
        </Grid>
      </div>
    );
  }
}

export default MitigationInformation;
